import { useGetLoyaltyAccount } from '~/hooks/apis/loyalty/useGetLoyaltyAccount';

import ApiError from '~/types/ApiError';

function isLoyaltyAccountNotFound(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}

/**
 * Société account lookup for Infinite existing-customer enrolment.
 * A 404 means the customer is not yet enrolled — not a lookup failure.
 */
export function useInfiniteCustomerLoyaltyLookup(customerId: string | null | undefined) {
  const enabled = !!customerId;
  const query = useGetLoyaltyAccount(customerId, enabled);

  if (!enabled) {
    return {
      accountSummary: null,
      currentTier: null,
      hasSocieteAccount: false,
      accountLookupFailed: false,
      accountLookupPending: false,
    };
  }

  const isNotEnrolled = query.isError && isLoyaltyAccountNotFound(query.error);

  const accountSummary = isNotEnrolled ? null : (query.data?.result?.accountSummary ?? null);

  return {
    accountSummary,
    currentTier: accountSummary?.tier ?? null,
    hasSocieteAccount: accountSummary !== null,
    accountLookupFailed: query.isError && !isNotEnrolled,
    accountLookupPending: query.isLoading,
  };
}
